<script>
import { extend } from 'sk-ui/lib/utils/util.js'
import { getAvailableHeight } from 'sky-engine/utils/dom'
import formController from 'sky-engine/views/formController'
import { createViewVNode } from 'sky-engine/views/ViewManager'

import ptFormView from '../../../../../../store/modules/pocMng/metaData/ptFormForScene'

import { createProject, editProject } from '@/api/project'
import { getIndustryList, getProjectType } from '@/api/setting'
import store from '@/store'

export default {
  name: 'SkyStepViewCreateProject',
  components: {
    formController
  },
  props: {
    projectId: {
      type: String
    },
    projectState: {
      type: String,
      default: null
    }
  },
  methods: {
    trimFormData(formData) {
      if (formData.customer) {
        formData.customer = formData.customer.trim()
      }
      if (formData.projectName) {
        formData.projectName = formData.projectName.trim()
      }
      if (formData.crmOrderId) {
        formData.crmOrderId = formData.crmOrderId.trim()
      }
    },
    updateAvailableHeight() {
      this.$refs.SkyStepViewCreateProject.availableHeight = getAvailableHeight(this.$el) + this._rem2px(55)
    },
    getData() {
      return {
        dataChange: false,
        busDATA: {}
      }
    },
    updateData() {
      getIndustryList().then(res => {
        var list = res.data.content.itemArr
        var changeList = []
        for (const iterator of list) {
          changeList.push({
            id: iterator.id,
            value: iterator.id,
            code: iterator.industryCode,
            label: iterator.industryName
          })
        }

        this.$refs.SkyStepViewCreateProject.view.content[0].$options = changeList
        if (this.projectId != null) {
          this.$refs.SkyStepViewCreateProject.view.content[0].$el = {
            class: 'wsp-custom-edit-industry-disabled',
            disabled: true
          }
        }
      })
      getProjectType().then(res => {
        var list = res.data.content.itemArr
        var changeList = []
        for (const iterator of list) {
          changeList.push({
            id: iterator.id,
            value: iterator.id,
            code: iterator.label,
            label: iterator.label
          })
        }
        var idIndex = this.$refs.SkyStepViewCreateProject.view.content.findIndex(item => {
          return item.$id === 'projectType'
        })
        this.$refs.SkyStepViewCreateProject.view.content[idIndex].$options = changeList
      })
    },
    async saveStep() {
      let result = false

      await this.$refs.SkyStepViewCreateProject.formRef.validate(valid => {
        result = valid
      })
      if (!result) {
        this.$store.dispatch('OpenNotification', { message: '表单存在必填项未填写，请确认', type: 'error' })
        return false
      }
      var from_data = this.$refs.SkyStepViewCreateProject.$refs.renderForm.value
      this.trimFormData(from_data)
      var reportSize = 0
      var list = []
      let bindReportTooMore = false
      if (from_data.envRelateSceneArr) {
        from_data.envRelateSceneList = from_data.envRelateSceneArr.map(item => {
          reportSize += item.envData.length
          if (reportSize > 5) {
            bindReportTooMore = true
          }
          item.envData.map(obj => list.push(obj.id))
          return {
            collectReportIdArr: item.envData.map(obj => obj.id),
            sceneId: item.scene
          }
        })
      }
      if (bindReportTooMore) {
        this.$store.dispatch('OpenNotification', { message: '一个场景最多只支持绑定5个报告', type: 'error' })
        return false
      }
      if (!result) {
        return false
      }
      from_data.salesId = from_data.salesIdLabel.id
      from_data.presalesId = from_data.presalesIdLabel.id
      from_data.postsalesIdList = []
      from_data.postsalesIdLabelList.forEach(element => {
        from_data.postsalesIdList.push(element.id)
      })
      from_data.extensionIdList = []
      from_data.extensionIdLabelList?.forEach(element => {
        from_data.extensionIdList.push(element.id)
      })
      from_data.postsalesLeaderList = []
      from_data.postsalesLeaderLabelList?.forEach(element => {
        from_data.postsalesLeaderList.push(element.id)
      })
      var industryMapOption = this.$refs.SkyStepViewCreateProject.$refs.renderForm.content[0].$options
      var industryMapOptionMap = {}
      for (const element of industryMapOption) {
        industryMapOptionMap[element.id] = element
      }
      if (this.projectId) {
        from_data.id = this.projectId
        await editProject(from_data).then(res => {
          this.$emit('changeProjectId', {
            projectId: this.projectId,
            customer: from_data.customer,
            industryCode: industryMapOptionMap[from_data.industryId].code,
            industryId: from_data.industryId
          })
          result = false
        })
      }

      return result
    },
    async gotoNextPreVliate() {
      return true
    },
    async gotoNextStep() {
      let result = false

      await this.$refs.SkyStepViewCreateProject.formRef.validate(valid => {
        result = valid
      })

      var from_data = this.$refs.SkyStepViewCreateProject.$refs.renderForm.value

      var reportSize = 0
      var list = []
      let bindReportTooMore = false
      if (from_data.envRelateSceneArr) {
        from_data.envRelateSceneList = from_data.envRelateSceneArr.map(item => {
          reportSize += item.envData.length
          if (reportSize > 5) {
            bindReportTooMore = true
          }
          item.envData.map(obj => list.push(obj.id))
          return {
            collectReportIdArr: item.envData.map(obj => obj.id),
            sceneId: item.scene
          }
        })
      }
      if (bindReportTooMore) {
        this.$store.dispatch('OpenNotification', { message: '一个场景最多只支持绑定5个报告', type: 'error' })
        return false
      }
      if (!result) {
        this.$store.dispatch('OpenNotification', { message: '还有必填项未填写，请检查！', type: 'error' })
        return false
      }
      from_data.salesId = from_data.salesIdLabel.id
      from_data.presalesId = from_data.presalesIdLabel.id
      from_data.postsalesIdList = []
      from_data.postsalesIdLabelList.forEach(element => {
        from_data.postsalesIdList.push(element.id)
      })
      from_data.extensionIdList = []
      from_data.extensionIdLabelList?.forEach(element => {
        from_data.extensionIdList.push(element.id)
      })
      from_data.postsalesLeaderList = []
      from_data.postsalesLeaderLabelList?.forEach(element => {
        from_data.postsalesLeaderList.push(element.id)
      })

      var industryMapOption = this.$refs.SkyStepViewCreateProject.$refs.renderForm.content[0].$options
      var industryMapOptionMap = {}
      for (const element of industryMapOption) {
        industryMapOptionMap[element.id] = element
      }

      if (this.projectId) {
        from_data.id = this.projectId
        await editProject(from_data)
          .then(res => {
            this.$emit('changeProjectId', {
              projectId: this.projectId,
              customer: from_data.customer,
              industryCode: industryMapOptionMap[from_data.industryId].code,
              industryId: from_data.industryId
            })
          })
          .catch(e => {
            result = false
          })
      } else {
        await createProject(from_data)
          .then(res => {
            this.$emit('changeProjectId', {
              projectId: res.data.content,
              customer: from_data.customer,
              industryCode: industryMapOptionMap[from_data.industryId].code,
              industryId: from_data.industryId
            })
          })
          .catch(e => {
            result = false
          })
      }
      return result
    },
    gotoPreStep() {
      return false
    }
  },
  created() {
    this.updateData()
  },
  data() {
    const ptFormViewCopy = extend(true, {}, ptFormView)
    ptFormViewCopy.toolbar = {
      hasToolbar: false
    }
    //filter channel
    let isChannel = store.getters.baseInfo.channel
    if (isChannel) {
      let idIndex = ptFormViewCopy.view.content.findIndex(item => {
        return item.$id === 'crmOrderId'
      })
      if (idIndex > 0) {
        ptFormViewCopy.view.content.splice(idIndex, 1)
      }
      idIndex = ptFormViewCopy.view.content.findIndex(item => {
        return item.$id === 'projectArea'
      })
      if (idIndex > 0) {
        ptFormViewCopy.view.content.splice(idIndex, 1)
      }
      idIndex = ptFormViewCopy.view.content.findIndex(item => {
        return item.$id === 'postsalesLeaderLabelList'
      })
      if (idIndex > 0) {
        ptFormViewCopy.view.content.splice(idIndex, 1)
      }
      idIndex = ptFormViewCopy.view.content.findIndex(item => {
        return item.$id === 'extensionIdLabelList'
      })
      if (idIndex > 0) {
        ptFormViewCopy.view.content.splice(idIndex, 1)
      }
    }
    if (this.projectId) {
      ptFormViewCopy.params = {
        id: this.projectId
      }
      ptFormViewCopy.needFetchFillInfo = true
      this.$emit('showBtns', {
        preStep: false,
        nextStep: true,
        saveStep: false,
        enableTabChange: true
      })
    } else {
      this.$emit('showBtns', {
        preStep: false,
        nextStep: true,
        saveStep: false,
        enableTabChange: true
      })
    }

    ptFormViewCopy.ref = 'SkyStepViewCreateProject'
    const metaView = ptFormViewCopy

    return {
      metaView: metaView
    }
  },
  render(h) {
    return createViewVNode(this.metaView, h)
  }
}
</script>
